import { render, staticRenderFns } from "./social-icon.vue?vue&type=template&id=3c9f5479&"
import script from "./social-icon.vue?vue&type=script&lang=js&"
export * from "./social-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c9f5479')) {
      api.createRecord('3c9f5479', component.options)
    } else {
      api.reload('3c9f5479', component.options)
    }
    module.hot.accept("./social-icon.vue?vue&type=template&id=3c9f5479&", function () {
      api.rerender('3c9f5479', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/social-icon.vue"
export default component.exports